<div class="form">
  <mat-dialog-content>
    <div class="row">
      <div class="col-12 text-center">
        <i class="fas fa-exclamation-triangle alert"></i>
      </div>
    </div>
    <div class="row text-center">
      <h3>{{ data.title | translate }}</h3>
      <p>{{ data.text | translate }}</p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="center" class="mt-3">
    <button mat-flat-button type="button" mat-dialog-close>
      {{ data.cancelText | translate }}
    </button>
    <button mat-flat-button color="primary" type="submit" (click)="submit()">
      {{ data.acceptText | translate }}
    </button>
  </mat-dialog-actions>
</div>
